import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'

const AppForm = ({
  values,
  handleChange,
  errors,
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='max_forever_year'
          name='max_forever_year'
          colSize='3'
          inputLabel='Max Forever Year'
          className='mb-3'
          placeholder='Enter max forever year...'
          value={values.max_forever_year}
          handleTextInput={handleChange}
          feedbackInvalid={errors.max_forever_year}
          invalid={errors.max_forever_year}
        />
        <FormTextInput 
          id='company_code'
          name='company_code'
          colSize='3'
          inputLabel='Company Code'
          className='mb-3'
          placeholder='Enter company code...'
          value={values.company_code}
          handleTextInput={handleChange}
          feedbackInvalid={errors.company_code}
          invalid={errors.company_code}
        />
        <FormTextInput 
          id='platform_name'
          name='platform_name'
          colSize='3'
          inputLabel='Platform Name'
          className='mb-3'
          placeholder='Enter platform name...'
          value={values.platform_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.platform_name}
          invalid={errors.platform_name}
        />
        <FormTextInput 
          id='platform_name_supported_team'
          name='platform_name_supported_team'
          colSize='3'
          inputLabel='Supported Team'
          className='mb-3'
          placeholder='Enter name of supported team...'
          value={values.platform_name_supported_team}
          handleTextInput={handleChange}
          feedbackInvalid={errors.platform_name_supported_team}
          invalid={errors.platform_name_supported_team}
        />
        <FormTextInput 
          id='signature_name'
          name='signature_name'
          colSize='3'
          inputLabel='Signature Name'
          className='mb-3'
          placeholder='Enter signature name...'
          value={values.signature_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.signature_name}
          invalid={errors.signature_name}
        />
      </CRow>
    </>
  )
}

export default AppForm